/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UpdatePalReauthGeneratedDocumentSelection200ResponseData } from './UpdatePalReauthGeneratedDocumentSelection200ResponseData';
import {
    UpdatePalReauthGeneratedDocumentSelection200ResponseDataFromJSON,
    UpdatePalReauthGeneratedDocumentSelection200ResponseDataFromJSONTyped,
    UpdatePalReauthGeneratedDocumentSelection200ResponseDataToJSON,
    UpdatePalReauthGeneratedDocumentSelection200ResponseDataToJSONTyped,
} from './UpdatePalReauthGeneratedDocumentSelection200ResponseData';

/**
 * 
 * @export
 * @interface UpdatePalReauthGeneratedDocumentSelection200Response
 */
export interface UpdatePalReauthGeneratedDocumentSelection200Response {
    /**
     * 
     */
    data?: UpdatePalReauthGeneratedDocumentSelection200ResponseData;
}

/**
 * Check if a given object implements the UpdatePalReauthGeneratedDocumentSelection200Response interface.
 */
export function instanceOfUpdatePalReauthGeneratedDocumentSelection200Response(value: object): value is UpdatePalReauthGeneratedDocumentSelection200Response {
    return true;
}

export function UpdatePalReauthGeneratedDocumentSelection200ResponseFromJSON(json: any): UpdatePalReauthGeneratedDocumentSelection200Response {
    return UpdatePalReauthGeneratedDocumentSelection200ResponseFromJSONTyped(json, false);
}

export function UpdatePalReauthGeneratedDocumentSelection200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePalReauthGeneratedDocumentSelection200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : UpdatePalReauthGeneratedDocumentSelection200ResponseDataFromJSON(json['data']),
    };
}

export function UpdatePalReauthGeneratedDocumentSelection200ResponseToJSON(json: any): UpdatePalReauthGeneratedDocumentSelection200Response {
    return UpdatePalReauthGeneratedDocumentSelection200ResponseToJSONTyped(json, false);
}

export function UpdatePalReauthGeneratedDocumentSelection200ResponseToJSONTyped(value?: UpdatePalReauthGeneratedDocumentSelection200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': UpdatePalReauthGeneratedDocumentSelection200ResponseDataToJSON(value['data']),
    };
}

